import { List } from "immutable";
import { createSelector } from "reselect";

import { CourseId } from "../models/state/courses/Courses";
import { SectionId, Sections } from "../models/state/sections/Sections";
import { getAllSections, getCourseSectionIds } from "./state";
import * as sectionsSelectors from "./state/sections";

export function makeGetCourseLeafSectionIds(courseId: CourseId) {
  return createSelector(
    getAllSections,
    (state: any) => getCourseSectionIds(state, courseId),
    getLeafSectionIds
  );
}

export function getLeafSectionIds(
  sections: Sections,
  sectionIds?: List<SectionId>
) {
  if (!sectionIds) {
    return List<SectionId>();
  }

  return sectionIds
    .map((sectionId: string) =>
      sectionsSelectors.recursivelyGetLeafSectionIds(sections, sectionId)
    )
    .flatten() as List<SectionId>;
}
